import moduleDrilling from "../../store/moduleDrilling.js";
import employeeSideView from "./components/employeeSideView.vue"
import employeeService from "./employeeService.js"
import vSelect from 'vue-select'

export default {
  components: {
    employeeSideView,
    'v-select': vSelect
  },
  data() {
    return {
      selectedMainProjectId: null,
      sidebarActive: false,
      sidebarData: {},
      companyId: null,
      companies: [],
      employees: []
    };
  },
  watch: {
    companyId() {
      this.refreshEmployees();
    }
  },
  mounted() {
    this.$vs.loading();
    employeeService.fetchCompaniesByProjectId(this.$store.state.projectId, this).then((response) => {
      this.companies = response.data.model;
      this.companyId = this.companies[0].companyId;

      this.refreshEmployees();
    }).finally(() => {
      this.$vs.loading.close();
    })    
  },
  created() {
    if (!moduleDrilling.isRegistered) {
      this.$store.registerModule("drilling", moduleDrilling);
      moduleDrilling.isRegistered = true;
    }
  },
  methods: {
    refreshEmployees() {
      if (this.companyId === null) return;
      return employeeService.fetchEmployeesByCompanyId(this.companyId, this)
        .then((response) => { 
          this.employees = response.data.model;
          this.$refs.listCard.removeRefreshAnimation();
        })
    },
    addEmployee() {
      this.sidebarData = { };
      this.toggleSidebar(true);
    },
    editEmployee(employee) {
      this.sidebarData = structuredClone(employee);
      this.toggleSidebar(true);
    },
    toggleSidebar(val = false) {
      this.sidebarActive = val;
    },
    onUpdated() {
      this.$notifySaveSuccess();
      this.toggleSidebar(false);
      this.refreshEmployees();
    },
    onInserted() {
      this.$notifySaveSuccess();
      this.toggleSidebar(false);
      this.refreshEmployees();
    },

    openDeleteConfirm(id) {
      this.$deleteConfirmation({
        text: this.$t('Drilling.Employees.ConfirmDelete'),
        accept: () => this.deleteEmployee(id)
      });
    },

    deleteEmployee(id) {
      employeeService.deleteEmployee(id, this)
        .then(() => {
          this.$notifyDeleteSuccess(this.$t("Drilling.Employees.DeletedConfirmation"));
          this.$refs.listCard.refreshcard();
        }).catch((error) => {
          if (error.response.status === 409) {
            this.$refs.listCard.refreshcard();
          }
        });
    }
  }
};
